import { setMeta } from '@/router/middleware'
import routerView from '@/views/dashboard/routerView'


const Main = () => import ('@/views/dashboard/Main')


export default {
    path: 'dashboard',
    redirect: 'dashboard',
    component: routerView,
    children: [
        {
            path: '',
            name: 'dashboard',
            component: Main,
            meta: {
                middleware: [setMeta],
                labelTrans: 'dashboard',
            }
        },
    ]
}